import { render, staticRenderFns } from "./FileStatusMasuk.vue?vue&type=template&id=9f35ed30&scoped=true"
import script from "./FileStatusMasuk.vue?vue&type=script&lang=js"
export * from "./FileStatusMasuk.vue?vue&type=script&lang=js"
import style0 from "./FileStatusMasuk.vue?vue&type=style&index=0&id=9f35ed30&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f35ed30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f35ed30')) {
      api.createRecord('9f35ed30', component.options)
    } else {
      api.reload('9f35ed30', component.options)
    }
    module.hot.accept("./FileStatusMasuk.vue?vue&type=template&id=9f35ed30&scoped=true", function () {
      api.rerender('9f35ed30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/monitoring_pasien/FileStatusMasuk.vue"
export default component.exports